export default {"src":"/_next/static/media/featured_placeholder.6331dc82.svg","height":1098,"width":1440,"blurWidth":0,"blurHeight":0};